// extracted by mini-css-extract-plugin
module.exports = {"image":"section-voile-module--image--1FzVz"};